import React, { useContext, useEffect, useState } from 'react'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext'
import io from 'socket.io-client'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  SubText,
  ListItem,
  ErrorText,
  ProgressContainer,
  ProgressFill,
  SuccessText,
  ButtonsDiv,
  FinishButton,
  DisabledFinishButton,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import cross from '../../../../assets/addStockModal/cross.svg'

const FollowingStep = () => {
  const { setImportFromExcelModal } = useContext(StockContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const [stockPercentage, setStockPercentage] = useState<number>(0)
  const [successLines, setSuccessLines] = useState<number>(0)
  const [errorLines, setErrorLines] = useState<number>(0)
  const [createdInDataBaseLines, setCreatedInDataBaseLines] =
    useState<number>(0)
  const [updatedInDataBaseLines, setUpdatedInDataBaseLines] =
    useState<number>(0)
  const [updatedInOmieLines, setUpdatedInOmieLines] = useState<number>(0)
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    if (stockPercentage === 100) {
      const timer = setTimeout(() => {
        setShowButton(true)
      }, 1000)

      return () => clearTimeout(timer)
    } else {
      setShowButton(false)
    }
  }, [stockPercentage])

  useEffect(() => {
    const rawUrl = process.env.REACT_APP_SOCKET_URL || window.location.origin
    const socketUrl = rawUrl.startsWith('ws') ? rawUrl.replace(/^ws/, 'http') : rawUrl
    const { token } = (window as any).localStorage ? { token: localStorage.getItem('token') } : { token: undefined }
    let triedPolling = false

    const createSocket = (transports: any[]) =>
      io(socketUrl, {
        auth: { token },
        query: { token },
        transports,
        reconnection: true,
        timeout: 5000,
        path: '/socket.io',
        autoConnect: false,
        forceNew: true,
      })

    let socket: any = createSocket(['websocket', 'polling'])

    const attachListeners = (sock: any) => {
      sock.on('conclusionsEvent', (payload: any) => {
        const {
          createdInDatabase = 0,
          updatedInDatabase = 0,
          updatedInOmie = 0,
          percentageComplete = 0,
          success = 0,
          error = 0,
        } = payload || {}

        setStockPercentage(percentageComplete)
        setSuccessLines(success)
        setErrorLines(error)
        setCreatedInDataBaseLines(createdInDatabase)
        setUpdatedInDataBaseLines(updatedInDatabase)
        setUpdatedInOmieLines(updatedInOmie)
      })

      sock.on('connect_error', (err: any) => {
        console.error('[FollowingStep] socket connect_error', err)
        if (!triedPolling) {
          triedPolling = true
          console.info('[FollowingStep] tentando fallback para polling')
          try {
            if (sock && typeof sock.close === 'function') sock.close()
          } catch (e) {
            console.warn('[FollowingStep] erro ao fechar socket antes do fallback', e)
          }
          socket = createSocket(['polling'])
          attachListeners(socket)
          try {
            socket.connect()
          } catch (e) {
            console.warn('[FollowingStep] erro ao conectar com polling', e)
          }
        }
      })
    }

    attachListeners(socket)

    try {
      socket.connect()
    } catch (e) {
      console.warn('[FollowingStep] erro ao iniciar conexão socket', e)
    }

    return () => {
      try {
        if (socket) {
          if (typeof socket.off === 'function') {
            socket.off('conclusionsEvent')
            socket.off('connect_error')
          }

          if (typeof socket.close === 'function') socket.close()
          else if (typeof socket.disconnect === 'function') socket.disconnect()
        }
      } catch (e) {
        console.warn('[FollowingStep] erro durante cleanup do socket', e)
      }
    }
  }, [])

  const ProgressBar = (props: any) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Importação em andamento...</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <SubText>Esse processo pode levar alguns minutos.</SubText>
      <ProgressBar completion={stockPercentage} />
      <ul>
        <ListItem>
          Linhas processadas com <SuccessText>sucesso</SuccessText>:{' '}
          {successLines}
        </ListItem>
        <ListItem>
          Linhas processadas com <ErrorText>erro</ErrorText>: {errorLines}
        </ListItem>
        <ListItem>
          Linhas criadas com sucesso no banco: {createdInDataBaseLines}
        </ListItem>
        <ListItem>
          Linhas atualizadas com sucesso no banco: {updatedInDataBaseLines}
        </ListItem>
        <ListItem>
          Linhas atualizadas com sucesso na omie: {updatedInOmieLines}
        </ListItem>
      </ul>
      <ButtonsDiv>
        {showButton ? (
          <FinishButton onClick={() => window.location.reload()}>
            Concluir
          </FinishButton>
        ) : (
          <DisabledFinishButton>Concluir</DisabledFinishButton>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default FollowingStep
